import React from 'react';
import { Outlet } from 'react-router-dom';

const InvitationsHome = () => {
  return (
   <>
   <div className="row">
        <div className="col-12">
          <div className="card my-4">
           


            <Outlet /> 
            </div>
            </div>
            </div> 
            </>
  );
};

export default InvitationsHome;